var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSundialLogoSmallDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.003,
    height: 12.998,
    viewBox: "0 0 13.003 12.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_284",
    "data-name": "Subtraction 284",
    d: "M-15426.5-12265a6.509,6.509,0,0,1-6.5-6.5,6.509,6.509,0,0,1,6.5-6.5,6.506,6.506,0,0,1,6.5,6.5A6.506,6.506,0,0,1-15426.5-12265Zm-.008-10.644a.583.583,0,0,0-.419.178.587.587,0,0,0-.166.427v3.54a.58.58,0,0,0,.174.414l2.363,2.366a.6.6,0,0,0,.418.171.588.588,0,0,0,.418-.175.581.581,0,0,0,.171-.417.579.579,0,0,0-.175-.415l-2.188-2.188v-3.3a.591.591,0,0,0-.17-.431A.609.609,0,0,0-15426.5-12275.645Z",
    transform: "translate(15433.001 12277.999)",
    fill: "#f8f8f8",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSundialLogoSmallDark);
export default __webpack_public_path__ + "static/media/sundial-logo-small-dark.0ac629ace498cb6faac6a8c1f78745d4.svg";
export { ForwardRef as ReactComponent };